"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e="en-US";exports.formatDateTime=(t,r,a)=>{const o=Array.isArray(r)?[...r,e]:[r,e];return new Intl.DateTimeFormat(o,a).format(new Date(t))};
//# sourceMappingURL=format.js.map
